import {Directive, ElementRef} from '@angular/core';
// import {BrowserDomAdapter} from '@angular/platform/browser';

@Directive({
    selector: '[borda-animada]',
    host: {
        '(focus)': 'onFocus()',
        '(blur)': 'onBlur()'
    }
})
export class BordaAnimadaDirective {
    private _el: HTMLElement;

    constructor(el: ElementRef) {
        this._el = el.nativeElement;
    }

    onFocus() {
        this._el.parentElement.classList.add('fg-toggled');

        if (this._el.classList.contains('ng-valid')) {
            
            /*this._el
            if (this._el.parentElement.parentElement.parentElement.classList.contains('form-group')) {
                this._el.parentElement.parentElement.parentElement.classList.add('has-success');
            }*/
            
            if (this._el.parentElement.classList.contains('form-group')) {
                this._el.classList.add('has-success');
            }
        } else if (this._el.classList.contains('ng-invalid')) {
            if (this._el.parentElement.classList.contains('form-group')) {
                this._el.classList.add('has-error');
            }
        }
    }

    onBlur() {
        /*this._el.parentElement.classList.remove('fg-toggled');
        this._el.parentElement.parentElement.parentElement.classList.remove('has-success');
        this._el.parentElement.parentElement.parentElement.classList.remove('has-error');*/

        this._el.parentElement.classList.remove('fg-toggled');
        this._el.classList.remove('has-success');
        this._el.classList.remove('has-error');

        // if (this._el.classList.contains('ng-valid')) {
        //     if (this._el.parentElement.parentElement.parentElement.classList.contains('form-group')) {

        //     }
        // } else if (this._el.classList.contains('ng-invalid')) {
        //     if (this._el.parentElement.parentElement.parentElement.classList.contains('form-group')) {

        //     }
        // }
    }

}



// import {Directive, ElementRef} from '@angular/core';
// // import {BrowserDomAdapter} from '@angular/platform/browser';

// @Directive({
//     selector: '[borda-animada]',
//     host: {
//         '(focus)': 'onFocus()',
//         '(blur)': 'onBlur()'
//     }
// })
// export class BordaAnimadaDirective {
//     private _el: HTMLElement;

//     constructor(el: ElementRef) {
//         this._el = el.nativeElement;
//     }

//     onFocus() {
//         this._el.parentElement.classList.add('fg-toggled');

//         if (this._el.classList.contains('ng-valid')) {
            
//             /*this._el
//             if (this._el.parentElement.parentElement.parentElement.classList.contains('form-group')) {
//                 this._el.parentElement.parentElement.parentElement.classList.add('has-success');
//             }*/
            
//             if (this._el.parentElement.classList.contains('form-group')) {
//                 this._el.classList.add('has-success');
//             }
//         } else if (this._el.classList.contains('ng-invalid')) {
//             if (this._el.parentElement.classList.contains('form-group')) {
//                 this._el.classList.add('has-error');
//             }
//         }
//     }

//     onBlur() {
//         /*this._el.parentElement.classList.remove('fg-toggled');
//         this._el.parentElement.parentElement.parentElement.classList.remove('has-success');
//         this._el.parentElement.parentElement.parentElement.classList.remove('has-error');*/

//         this._el.parentElement.classList.remove('fg-toggled');
//         this._el.classList.remove('has-success');
//         this._el.classList.remove('has-error');

//         // if (this._el.classList.contains('ng-valid')) {
//         //     if (this._el.parentElement.parentElement.parentElement.classList.contains('form-group')) {

//         //     }
//         // } else if (this._el.classList.contains('ng-invalid')) {
//         //     if (this._el.parentElement.parentElement.parentElement.classList.contains('form-group')) {

//         //     }
//         // }
//     }

// }


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/core/directives/borda-animada.directive.ts
 **/